import {
  DriverPumpAdjustmentsDetail,
  DriverPumpAdjustmentsDetailRequest,
  DriverPumpAdjustmentsInfoItem,
  DriverPumpAdjustmentsItem,
} from 'bus/driverPumpAdjustments/types';

import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../api';

const driverPumpAdjustmentsApi = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    // Основные методы для DriverPumpAdjustments
    getDriverPumpAdjustments: builder.query<DriverPumpAdjustmentsItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/driverPumpAdjustments/${data.id}`,
      }),
    }),
    createDriverPumpAdjustments: builder.mutation<void, DriverPumpAdjustmentsItem>({
      query: (data) => ({
        url: '/v1/driverPumpAdjustments/',
        method: 'POST',
        body: data,
      }),
    }),
    editDriverPumpAdjustments: builder.mutation<void, DriverPumpAdjustmentsItem>({
      query: (data) => ({
        url: `/v1/driverPumpAdjustments/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    deleteDriverPumpAdjustments: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/driverPumpAdjustments/${data.id}`,
        method: 'DELETE',
      }),
    }),
    getDriverPumpAdjustmentsInfo: builder.query<DriverPumpAdjustmentsInfoItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/driverPumpAdjustments/${data.id}/info`,
      }),
    }),

    // Методы для DriverPumpAdjustmentsDetail
    getDriverPumpAdjustmentsDetailList: builder.query<DriverPumpAdjustmentsDetail[], PayloadRequest>({
      query: (data) => ({
        url: `/v1/driverPumpAdjustments/${data.id}/details`,
      }),
    }),
    getDriverPumpAdjustmentsDetailOne: builder.query<DriverPumpAdjustmentsDetail, PayloadRequest>({
      query: (data) => ({
        url: `/v1/driverPumpAdjustments/details/${data.id}`,
      }),
    }),
    createDriverPumpAdjustmentsDetail: builder.mutation<void, DriverPumpAdjustmentsDetailRequest>({
      query: (data) => ({
        url: `/v1/driverPumpAdjustments/${data.adjustmentId}/details`,
        method: 'POST',
        body: data,
      }),
    }),
    editDriverPumpAdjustmentsDetail: builder.mutation<void, DriverPumpAdjustmentsDetailRequest>({
      query: (data) => ({
        url: `/v1/driverPumpAdjustments/details/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    deleteDriverPumpAdjustmentsDetail: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/driverPumpAdjustments/details/${data.id}`,
        method: 'DELETE',
      }),
    }),

    // Методы для DriverPumpSalary
    createDriverPumpSalary: builder.mutation<void, { date: string; driverId: number; comment: string }>({
      query: (data) => ({
        url: '/v1/driverPumpSalary/',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useGetDriverPumpAdjustmentsQuery,
  useLazyGetDriverPumpAdjustmentsQuery,
  useCreateDriverPumpAdjustmentsMutation,
  useEditDriverPumpAdjustmentsMutation,
  useDeleteDriverPumpAdjustmentsMutation,
  useGetDriverPumpAdjustmentsInfoQuery,
  useLazyGetDriverPumpAdjustmentsInfoQuery,
  useGetDriverPumpAdjustmentsDetailListQuery,
  useLazyGetDriverPumpAdjustmentsDetailListQuery,
  useGetDriverPumpAdjustmentsDetailOneQuery,
  useLazyGetDriverPumpAdjustmentsDetailOneQuery,
  useCreateDriverPumpAdjustmentsDetailMutation,
  useEditDriverPumpAdjustmentsDetailMutation,
  useDeleteDriverPumpAdjustmentsDetailMutation,
  useCreateDriverPumpSalaryMutation,
} = driverPumpAdjustmentsApi;
